(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('NewScheduledAnnualEventController', NewScheduledAnnualEventController);

  /* ngInject */
  function NewScheduledAnnualEventController($state, $stateParams, Flash, annualEventService, formErrorsService, scheduledAnnualEventService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.annualEvent = {};
    vm.createScheduledAnnualEvent = createScheduledAnnualEvent;
    vm.getAnnualEvent = getAnnualEvent;
    vm.scheduledAnnualEvent = {};
    vm.scheduledAnnualEventForm = {};

    vm.activate();

    function activate() {
      vm.getAnnualEvent();
    }

    function createScheduledAnnualEvent() {
      scheduledAnnualEventService(sessionService.getAuthToken()).create({annualEventId: $stateParams.annualEventId, scheduled_annual_event: vm.scheduledAnnualEvent}, _createScheduledAnnualEventSuccess, _createScheduledAnnualEventFailure);
    }

    function getAnnualEvent() {
      annualEventService(sessionService.getAuthToken()).get({id: $stateParams.annualEventId}, response => vm.annualEvent = response);
    }

    function _createScheduledAnnualEventSuccess(_response) {
      $state.go('application.compliance_services.annual_events');
      Flash.create('success', 'Annual event successfully scheduled.');
    }

    function _createScheduledAnnualEventFailure(response) {
      Flash.create('danger', 'An error occurred with the submission, please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.scheduledAnnualEventForm, response);
    }
  }
})();
